import { createSelector } from 'reselect';

const getAllBranchesState = state => state.Branches.allBranches;

export const getAllBranches = createSelector(getAllBranchesState, allBranches => allBranches);

export default getAllBranches;
